export default "__VITE_ASSET__fa66ebd1__"